<template>
    <div class="activities">
        <p-header title="活動專區"/>
        <div class="activity" v-for="activity in activitiesList" :key="activity.id">
            <img :src="activity.photo_small.url" @click="goTarget(activity)">
        </div>
    </div>
</template>

<script>
    import Header from "./components/Header";
    import { mapGetters } from 'vuex';

    export default {
        name: "Activities",
        components: {
            'p-header': Header,
        },
        computed: {
            ...mapGetters(['activitiesList'])
        },
        methods: {
            goTarget(activity) {
                if (activity.type === 'url') {
                    window.open(activity.target, '_blank');

                    return;
                }

                let to = { name: 'home' };

                if (activity.type === 'shop') to = { name: 'shop', params: { id: activity.target } };
                if (activity.type === 'category') to = { name: 'ShopList', query: { title: activity.title, onlyCategory: activity.target } };
                if (activity.type === 'coupon') to = { name: 'coupons', query: { code: activity.target }};
                this.$router.push(to);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .activities {
        .activity {
            margin: 15px;

            img {
                width: 100%;
                height: auto;
            }
        }
    }
</style>